import { computed } from 'vue'
import { useCurrentStaffQuery } from './useStaff.generated.ts'

export const useStaff = () => {
  const {
    result: currentStaffQueryResult,
    loading,
    error,
  } = useCurrentStaffQuery()

  const currentStaff = computed(
    () => currentStaffQueryResult.value?.viewer.staff
  )

  return {
    currentStaff,
    loading,
    error,
  }
}
